document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    function checkVisibility() {
        const elements = document.querySelectorAll('.scroll-animation');
        const videos = document.querySelectorAll('video');
        const bottomOfScreen = window.scrollY + window.innerHeight - 200;
        const topOfScreen = window.scrollY;

        elements.forEach(function(element) {
            const topOfElement = element.getBoundingClientRect().top + window.scrollY;
            const bottomOfElement = topOfElement + element.offsetHeight;

            if (bottomOfScreen > topOfElement && topOfScreen < bottomOfElement && !element.classList.contains('is-visible')) {
                element.classList.add('is-visible');
            }
        });
        videos.forEach(function(video) {
            const topOfElement = video.getBoundingClientRect().top + window.scrollY;
            const bottomOfElement = topOfElement + video.offsetHeight;
            if (bottomOfScreen > topOfElement && topOfScreen < bottomOfElement) {
                if (video.paused) {
                    video.play();
                }
            } else {
                if (!video.paused) {
                    video.pause();
                }
            }
        });
    }

    setTimeout(function() {
        checkVisibility();
    }, 2000);

    window.addEventListener('scroll', function() {
        checkVisibility();
    });
});